module.exports = __webpack_public_path__ + "img/nova.86dc8f63.86dc8f63.png";